import { Trans, useTranslation } from "react-i18next";
import { Button } from "@components/Button";
import { useModalStore } from "@store/modal/modal";
import { EnefitConsultationBannerModal } from "./components/EnefitConsultationBannerModal/EnefitConsultationBannerModal";

export const EnefitConsultationBanner: React.FC = () => {
  const { create } = useModalStore();
  const { t } = useTranslation();

  const openEnefitConsultationModal = () => {
    create((modalProps) => <EnefitConsultationBannerModal {...modalProps} />);
  };

  return (
    <div className="flex w-full flex-col items-center justify-between gap-2 rounded-2xl bg-[#00973A] p-4 sm:flex-row">
      <img
        src="/images/bills/banners/enefit-logo-white.png"
        alt="enefit"
        className="sm:p-2"
      />
      <p className="text-center text-2xl text-base-white">
        <Trans
          i18nKey={"electricityLeads.enefitConsultation.title"}
          components={{ bold: <b></b> }}
        />
      </p>
      <Button
        onClick={openEnefitConsultationModal}
        className="min-w-[103px] bg-base-white text-[#00973A] hover:bg-grey-light active:bg-grey-hover"
      >
        {t("electricityLeads.enefitConsultation.buttons.check")}
      </Button>
    </div>
  );
};
